abstract class BaseTracker {
  tracker: any;

  initialized = false;

  abstract initialize(): void;

  protected getTracker() {
    if (!this.initialized) {
      this.initialize();
    }
    return this.tracker;
  }
}

export default BaseTracker;
